import React from 'react';
import tw from 'twin.macro';

export const TextLine = ({
  Type = 'span',
  children,
  text = children,
  bold,
  black,
  smaller,
  small,
  ...restProps
}) => (
  <Type
    css={[
      tw`text-sm md:text-base text-default group-[.text-light]:text-light group-[.text-dark]:text-dark`,
      bold && tw`font-bold`,
      black && tw`!text-xs font-black uppercase`,
      smaller && tw`!text-sm`,
      small && tw`!text-xs leading-loose`,
    ]}
    {...restProps}
  >
    {text}
  </Type>
);
